class TxnAction {
  performAction(txns) {
    if (!Array.isArray(txns)) {
      throw new Error('txns must be an array');
    }
  }
}

export { TxnAction };
